<template>
    <div class="slideInner"
         v-if="slide"
         :data-index="index"
    >
        <fade-transition>
            <video class="slider-video"
                   :src="slide.url"
                   data-poster="posterFallback(slide)"
                   preload="metadata" muted playsinline
                   ref="video"
            >
            </video>
        </fade-transition>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
    props: ['slide', 'index',],
    data() {
        return {}
    },
    computed: {
        ...mapGetters('home', [
            'posterFallback',
            'poster',
        ]),
    },
    mounted() {
        this.onEnded()
    },
    methods: {
        ...mapActions('editors', {
            'nextSlide': 'nextSlide',
        }),
        onEnded() {
            this.$refs.video.onended = () => {
                this.nextSlide(this.index)
                    .then(() => {
                        this.$refs.video.play()
                    })
            }
        }
    }
}
</script>
